import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import * as pages from 'pages'

export default () => {
  return (
    <Router>
      <Route component={pages.Home} />
    </Router>
  )
}
